import './HeaderPressRelease.css';
import React from 'react';
import { get } from '../../utils';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import LazyPicture from '../atoms/LazyPicture';
import { headerImageStyle, commonStyles, ltrStyles, rtlStyles } from '../57_HeaderArticle1/HeaderArticle1';
import { getFormatedDate } from '../../utils';
var HeaderPressRelease = function HeaderPressRelease(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var showHeaderImage = Boolean(params && params.showHeaderImage === '1');
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  if (!fields) {
    console.warn('HeaderPressRelease component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [HeaderPressRelease component is empty: please provide data source]");
    }
    return null;
  }
  var introTextObject = get(fields, 'Intro Text') || get(fields, 'pageIntro'); //pageIntro
  var author = get(fields, 'author.fields.fullName.value', '');
  var hasPageTitle = Boolean(get(fields, 'pageTitle.value'));
  var hasPageIntro = Boolean(get(introTextObject, 'value'));
  var country = get(fields, 'location.fields.country.value', '');
  var city = get(fields, 'location.fields.city.value', '');
  var headerImageSrc = get(fields, 'headerImage.value.src', '');
  var headerImageAlt = get(fields, 'headerImage.value.alt', '');
  var hasDateOfIssue = Boolean(get(fields, 'dateOfIssue.value'));
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "header--article header-article-press-release",
    "data-cy": "header-press-release"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-md-10"
  }, author && /*#__PURE__*/React.createElement("p", {
    className: "body-medium ha__localization",
    "data-cy": "header-press-release-author"
  }, author), /*#__PURE__*/React.createElement("div", {
    className: "head-content"
  }, hasPageTitle && /*#__PURE__*/React.createElement(Text, {
    className: "h2 h__title",
    tag: "h1",
    field: fields.pageTitle
  })), country && city && /*#__PURE__*/React.createElement("div", {
    className: "h__desc"
  }, /*#__PURE__*/React.createElement("p", {
    className: "body-medium"
  }, /*#__PURE__*/React.createElement("span", null, hasDateOfIssue && "".concat(getFormatedDate(fields.dateOfIssue.value, sitecoreContext.language))), ", ", /*#__PURE__*/React.createElement("span", null, city), ", ", /*#__PURE__*/React.createElement("span", null, country))), hasPageIntro && /*#__PURE__*/React.createElement("div", {
    className: "ha__desc--desk"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-5"
  }, /*#__PURE__*/React.createElement(Text, {
    className: "body-large",
    tag: "p",
    field: introTextObject
  })))))), showHeaderImage && headerImageSrc && /*#__PURE__*/React.createElement("div", {
    className: "ha__img"
  }, /*#__PURE__*/React.createElement(LazyPicture, null, /*#__PURE__*/React.createElement("source", {
    media: "(min-width:769px)",
    srcSet: "".concat(headerImageSrc, "&cw=964&ch=417")
  }), /*#__PURE__*/React.createElement("img", {
    className: "img-article",
    src: "".concat(headerImageSrc, "&cw=500&ch=500"),
    alt: headerImageAlt
  }))), hasPageIntro && /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-md-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ha__desc"
  }, /*#__PURE__*/React.createElement(Text, {
    className: "body-large",
    tag: "p",
    field: fields.pageIntro
  }))))));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: "".concat(headerImageStyle, " ").concat(defaulStyles, " ").concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(rtl ? rtlImage : ltrImage, " ")
  }, children);
};
export var defaulStyles = "d1azu8wi";
var rtlImage = "rtu3hl8";
var ltrImage = "l1l81i4";
export default HeaderPressRelease;